import { Box, Button, Flex, Heading, Image, Spacer, Link as ChakraLink, IconButton } from '@chakra-ui/react';
import React from 'react';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import imagelogo from '../images/system logo.jpg';
import { Link as ReactLink } from "react-router-dom";
import resume from "../Assests/Kalyan-Kumar-Resume.pdf";
import { motion } from 'framer-motion';

const Home = () => {
  const resumeUrl = resume;

  const handleClick = () => {
    window.open(
      `https://drive.google.com/file/d/1GMDpYcl0BKf8UGT1ropTvW6gAaQA1fxb/view?usp=sharing`,
      "_blank",
      "noopener",
      "noreferrer"
    );
  };

  return (
    <div id="home">
      <Box pt={"5px"}>
        <Flex
          flexWrap={{ base: 'wrap', md: 'nowrap' }}
          align={{ base: 'center', md: 'flex-start' }}
          justify={{ base: 'center', md: 'space-between' }}
          m={{ base: '2', md: '5%' }}
        >
          <Box textAlign={{ base: 'center', md: 'left' }} w={{ base: '100%', md: '45%' }} m="auto">
            <motion.div
              initial={{ opacity: 0, x: -100 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 }}
            >
              <Heading as='h2' size='xl' noOfLines={1}>
                Hello 👋, it's me
              </Heading>

              <Heading as='h2' size='2xl' noOfLines={1} id="user-detail-name">
                Kalyan Kumar
              </Heading>
              <Spacer />
              <Heading as='h2' size='lg' noOfLines={1}>
                And I'm a
              </Heading>

              <Heading as='h2' size='xl' noOfLines={1}>
                Full Stack Web Developer.
              </Heading>
            </motion.div>
            <ChakraLink as={ReactLink} id="resume-link-2" to={resumeUrl} target="_blank" download justifyContent={"center"} p={"5px"}>
              <Button
                onClick={handleClick}
                display={{ base: "", md: "inline-flex" }}
                fontSize={"sm"}
                fontWeight={600}
                color={"white"}
                id="resume-button-2"
                _dark={{
                  background: "teal.500",
                  color: "white",
                }}
                bg="pink.400"
                _hover={{
                  bg: 'teal.500',
                }}
                
              >
                Resume
              </Button>
            </ChakraLink>

            <Flex justify={"center"} p={"5px"}>
              <ChakraLink href="https://github.com/kkalyankumar9" isExternal>
                <IconButton
                  aria-label="GitHub"
                  icon={<FaGithub />}
                  variant="ghost"
                  colorScheme="gray"
                  size='lg'
                />
              </ChakraLink>
              <ChakraLink href="https://www.linkedin.com/in/k-kalyan-kumar-a44321163/" isExternal>
                <IconButton
                  aria-label="LinkedIn"
                  icon={<FaLinkedin />}
                  variant="ghost"
                  colorScheme="blue"
                  size='lg'
                />
              </ChakraLink>
              <ChakraLink href="mailto:kkalyan2312@gmail.com" isExternal>
                <IconButton
                  aria-label="Email"
                  icon={<FaEnvelope />}
                  variant="ghost"
                  colorScheme="red"
                  size='lg'
                />
              </ChakraLink>
            </Flex>

          </Box>
          <Box w={{ base: '100%', md: '45%' }}>
            <Image w="100%" maxW="400px" src={imagelogo} alt="" className="home-img" />
          </Box>
        </Flex>

      </Box>
    </div>
  );
};

export default Home;
